export default __webpack_public_path__ + "static/media/logoBlue.d62c6c2b.svg";